import {ReasonTypeInfoMap, ReasonTypeType} from '@web/core/constants'
import {
    sendOrderApplyFailToNelo,
    sendOrderFailToNelo,
    sendOrderFailureToNelo,
    sendOrderInitToNelo,
    sendOrderTryToNelo,
    sendLeaveToNelo,
} from '@web/helpers/nelo'
import {actionLoggerCreator} from '@web/middlewares/logger'

import {PageSet} from '../../constants'

import type {RootState} from '../../interfaces'

const loggerMiddleware = actionLoggerCreator<RootState>({
    callbackLeaveAction: ({state, action, path, type}) => {
        sendLeaveToNelo({
            entry: state.common.entry,
            pageSet: PageSet,
            orderSheetId: state.common.seqID,
            message: action.type,
            type,
            path,
        })
    },
    callbackLogAction: ({state, log}) => {
        if (log.type === 'failure') {
            const {code, message} = log.info
            sendOrderFailureToNelo({
                entry: state.common.entry,
                orderSheetId: state.common.seqID,
                pageSet: PageSet,
                code,
                message,
            })
        } else if (log.type === 'info') {
            const {message} = log.info
            sendOrderInitToNelo({
                entry: state.common.entry,
                pageSet: PageSet,
                message,
            })
        } else if (log.type === 'orderTry') {
            const {code} = log.info
            sendOrderTryToNelo({
                entry: state.common.entry,
                code,
                orderSheetId: state.common.seqID,
                pageSet: PageSet,
            })
        } else if (log.type === 'orderFail') {
            const {orderProcessId, orderNo, code, message} = log.info
            sendOrderFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderProcessId,
                code,
                message,
                orderSheetId: state.common.seqID,
                pageSet: PageSet,
                level: ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR',
            })
        } else if (log.type === 'orderApplyFail') {
            const {orderNo, orderSheetId, orderProcessId, code, message, pageSet} = log.info
            sendOrderApplyFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderSheetId,
                orderProcessId,
                code,
                message,
                pageSet,
                level: code ? (ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR') : 'ERROR',
            })
        }
    },
})

export default loggerMiddleware
